<template>
  <div class="tab-item-content">
    <div class="statics">
      <div class="item red">
        <div class="tip">可提现总金额</div>
        <div class="value">
          <span class="small">￥</span
          >{{ comRuleData.pointFormat(statisticsData.cashBalanceTotal) }}
        </div>
      </div>
      <div class="item">
        <div class="tip">已提现总余额</div>
        <div class="value">
          <span class="small">￥</span
          >{{ comRuleData.pointFormat(statisticsData.cashAmountTotal) }}
        </div>
      </div>
      <div class="item">
        <div class="tip">业务人员总数</div>
        <div class="value">{{ statisticsData.salesUserTotal }}</div>
      </div>
      <div class="item">
        <div class="tip">客户总数</div>
        <div class="value">{{ statisticsData.numberCustomersTotal }}</div>
      </div>
      <div class="item">
        <div class="tip">已覆盖业务区域</div>
        <div class="value">{{ statisticsData.serviceAreaTotal }}</div>
      </div>
    </div>
    <div class="search-layout">
      <template v-if="!expanded">
        <div class="item-wrap long">
          <el-input
            size="small"
            v-model="formRef.nameLike"
            placeholder="业务人员ID/业务人员手机号/邀请人ID"
            clearable
          />
        </div>
      </template>
      <template v-else>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="业务人员ID"
            v-model="formRef.salesJobNumber"
            clearable
          />
        </div>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="业务员手机号"
            v-model="formRef.contactInformation"
            clearable
          />
        </div>
        <div class="item-wrap">
          <SelectArea
            ref="refSelectArea"
            size="small"
            placeholder="业务区域"
            clearable
            @change="handleChangeForArea"
          />
        </div>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="邀请人ID/手机号/姓名"
            v-model="formRef.inviterNameLike"
            clearable
          />
        </div>
        <div class="item-wrap long-small">
          <el-date-picker
            size="small"
            v-model="registrationTime"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="注册开始日期"
            end-placeholder="注册结束日期"
            clearable
          >
          </el-date-picker>
        </div>
        <div class="item-wrap long-small">
          <el-date-picker
            size="small"
            v-model="lastAccessTime"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="最后访问开始日期"
            end-placeholder="最后访问结束日期"
            clearable
          >
          </el-date-picker>
        </div>
      </template>
      <div class="item-wrap op">
        <el-button size="small" @click="resetForm">重置</el-button>
        <el-button type="primary" size="small" @click="handleSearch">
          搜索
        </el-button>
        <el-button type="text" size="small" @click="handleExpand()">
          {{ expanded ? "收起" : "展开"
          }}<i
            :class="{
              'el-icon-arrow-up': expanded,
              'el-icon-arrow-down': !expanded,
              'el-icon--right': true,
            }"
          ></i>
        </el-button>
      </div>
    </div>
    <div class="table-wrap">
      <MyTable
        :table-data="tableData"
        @sort-change="sortChange"
        :index="index"
        :selection="selection"
        :page="page"
        :operation="false"
        :table-option.sync="tableOption"
        @page-change="getList"
      >
        <!-- 业务人员ID -->
        <template slot="salesJobNumber" slot-scope="scope">
          <div class="sales-id-view" @click="handleLookSales(scope.$index)">
            {{ scope.row.salesJobNumber }}
          </div>
        </template>
        <!-- 客户数量 -->
        <template slot="numberCustomers" slot-scope="scope">
          <div>
            {{ scope.row.numberCustomers }}

            <el-button
              size="small"
              type="text"
              @click="handleLookNumberCustomers(scope.$index)"
            >
              <svg-icon icon-class="editIcon" class="default-icon" />
            </el-button>
          </div>
        </template>
        <!-- 接种数量 -->
        <template slot="inoculationQuantity" slot-scope="scope">
          <div>
            {{ scope.row.inoculationQuantity
            }}<el-button
              size="small"
              type="text"
              @click="handleLookInoculationQuantity(scope.$index)"
            >
              <svg-icon icon-class="editIcon" class="default-icon" />
            </el-button>
          </div>
        </template>
        <!-- 团员人数 -->
        <template slot="numberMembers" slot-scope="scope">
          <div>
            {{ scope.row.numberMembers
            }}<el-button
              size="small"
              type="text"
              @click="handleLookNumberMembers(scope.$index)"
            >
              <svg-icon icon-class="editIcon" class="default-icon" />
            </el-button>
          </div>
        </template>
        <!-- 邀请人ID -->
        <template slot="invitationNumber" slot-scope="scope">
          <div>
            {{ scope.row.invitationNumber
            }}<el-button
              size="small"
              type="text"
              @click="handleLookInvitationNumber(scope.$index)"
            >
              <svg-icon icon-class="zuzhiIcon" class="default-icon" />
            </el-button>
          </div>
        </template>
        <!-- 上月预估 -->
        <template slot="lastMonthEstimateAmount" slot-scope="scope">
          <div>
            {{ comRuleData.pointFormat(scope.row.lastMonthEstimateAmount) }}
          </div>
        </template>
        <!-- 本月预估 -->
        <template slot="thisMonthEstimateAmount" slot-scope="scope">
          <div>
            {{ comRuleData.pointFormat(scope.row.thisMonthEstimateAmount) }}
          </div>
        </template>
        <!-- 可提现余额 -->
        <template slot="cashBalance" slot-scope="scope">
          <div>
            {{ comRuleData.pointFormat(scope.row.cashBalance) }}
            <!-- <el-button
              size="small"
              type="text"
              @click="handleLookCashBalance(scope.$index)"
            >
              <svg-icon icon-class="editIcon" class="default-icon" />
            </el-button> -->
          </div>
        </template>
        <!-- 已提现金额 -->
        <template slot="cashAmount" slot-scope="scope">
          <div>
            {{ comRuleData.pointFormat(scope.row.cashAmount)
            }}<el-button
              size="small"
              type="text"
              @click="handleLookCashAmount(scope.$index)"
            >
              <svg-icon icon-class="editIcon" class="default-icon" />
            </el-button>
          </div>
        </template>
      </MyTable>
    </div>

    <MemberPersonNumDlg ref="refMemberPersonNumDlg" />
    <ClientNumDlgDlg ref="refClientNumDlgDlg" />
    <PickUpNumDlg ref="refPickUpNumDlg" />
    <InvitePersonDlg ref="refInvitePersonDlg" />
    <SuperiorInfoDlg ref="refSuperiorInfoDlg" @changeTab="handleChangeTab" />
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import MemberPersonNumDlg from "../dialog/MemberPersonNumDlg.vue";
import ClientNumDlgDlg from "../dialog/ClientNumDlg.vue";
import PickUpNumDlg from "../dialog/PickUpNumDlg.vue";
import InvitePersonDlg from "../dialog/InvitePersonDlg.vue";
import SuperiorInfoDlg from "../dialog/SuperiorInfoDlg.vue";

import SelectArea from "@/components/SelectArea/index.vue";

import {
  getSalesDataStatistics,
  getSalesUserStatisticsManage,
} from "@/api/externalSalesRule/index.js";

import _ from "lodash";
import dayjs from "dayjs";

export default {
  components: {
    MyTable,
    SelectArea,
    MemberPersonNumDlg,
    ClientNumDlgDlg,
    PickUpNumDlg,
    InvitePersonDlg,
    SuperiorInfoDlg,
  },
  data() {
    return {
      expanded: false,

      statisticsData: {
        cashBalanceTotal: 0, //可提现总余额
        cashAmountTotal: 0, //已提现总金额
        salesUserTotal: 0, //业务人员总数
        numberCustomersTotal: 0, //客户总数量
        serviceAreaTotal: 0, //已覆盖业务区域数量
      },

      registrationTime: "", //注册时间
      lastAccessTime: "", //最后访问时间

      formRef: {
        nameLike: "", //业务人员id/业务人员手机号/邀请人id
        salesJobNumber: "", //业务员id
        contactInformation: "", //联系方式
        applicationAreaProvinceCode: "", //申请区域-省编码
        applicationAreaCityCode: "", //申请区域-市编码
        applicationAreaCode: "", //申请区域-区编码
        inviterNameLike: "", //邀请人ID/手机号/姓名
        registrationStartTime: "", //注册时间-开始时间
        registrationEndTime: "", //注册时间-结束时间
        lastAccessStartTime: "", //最后访问时间-开始时间
        lastAccessEndTime: "", //最后访问时间-结束时间
        sortTag: "", //排序规则
      },

      tabsIndex: "-1",
      operation: true,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        {
          label: "业务人员ID",
          prop: "salesJobNumber",
          slot: true,
          minWidth: 120,
        },
        { label: "业务人员手机号", prop: "contactInformation", minWidth: 120 },
        { label: "业务区域", prop: "serviceArea", minWidth: 160 },
        {
          label: "客户数量",
          prop: "numberCustomers",
          sortable: "custom",
          slot: true,
          minWidth: 120,
          sortNum: 3,
        },
        {
          label: "接品数量",
          prop: "inoculationQuantity",
          sortable: "custom",
          slot: true,
          minWidth: 120,
          sortNum: 5,
        },
        {
          label: "团员人数",
          prop: "numberMembers",
          sortable: "custom",
          slot: true,
          minWidth: 120,
          sortNum: 7,
        },
        {
          label: "邀请人ID",
          prop: "invitationNumber",
          slot: true,
          minWidth: 120,
        },
        {
          label: "上月预估",
          prop: "lastMonthEstimateAmount",
          sortable: "custom",
          slot: true,
          minWidth: 120,
          sortNum: 9,
        },
        {
          label: "本月预估",
          prop: "thisMonthEstimateAmount",
          sortable: "custom",
          slot: true,
          minWidth: 120,
          sortNum: 11,
        },
        {
          label: "可提现余额",
          prop: "cashBalance",
          sortable: "custom",
          slot: true,
          minWidth: 120,
          sortNum: 13,
        },
        {
          label: "已提现总额",
          prop: "cashAmount",
          sortable: "custom",
          slot: true,
          minWidth: 120,
          sortNum: 15,
        },
        {
          label: "注册时间",
          prop: "registerTime",
          sortable: "custom",
          minWidth: 160,
          sortNum: 19,
        },
        {
          label: "最后访问时间",
          prop: "lastAccessTime",
          sortable: "custom",
          minWidth: 160,
          sortNum: 17,
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 50, 100],
      },
    };
  },
  created() {
    this.getSalesDataStatistics();
    this.getList();

    this.initEvent();
  },
  methods: {
    initEvent() {
      this.$bus.$on("refresh", () => {
        this.handleSearch();
      });
    },

    handleChangeTab(portableData) {
      this.$emit("changeTab", portableData);
    },
    handleChangeForArea(val) {
      this.formRef.applicationAreaProvinceCode = "";
      this.formRef.applicationAreaCityCode = "";
      this.formRef.applicationAreaCode = "";

      if (val instanceof Array && val.length == 1) {
        const labels = val[0].path;
        if (labels instanceof Array) {
          if (labels.length > 0) {
            this.formRef.applicationAreaProvinceCode = labels[0];
          }
          if (labels.length > 1) {
            this.formRef.applicationAreaCityCode = labels[1];
          }
          if (labels.length > 2) {
            this.formRef.applicationAreaCode = labels[2];
          }
        }
      }
    },
    handleLookSales(index) {
      const item = this.tableData[index];
      this.$refs.refSuperiorInfoDlg.open(item);
    },
    handleLookInvitationNumber(index) {
      const item = this.tableData[index];
      this.$refs.refInvitePersonDlg.open(item);
    },
    handleLookCashAmount(index) {
      //已提现余额
      const item = this.tableData[index];
      this.$emit("changeTab", {
        row: _.cloneDeep(item),
        tabindex: "4",
      });
    },
    handleLookCashBalance(index) {
      //可体现余额
      const item = this.tableData[index];
      this.$emit("changeTab", {
        row: _.cloneDeep(item),
        tabindex: "3",
      });
    },
    handleLookNumberMembers(index) {
      const item = this.tableData[index];
      this.$refs.refMemberPersonNumDlg.open(item);
    },
    handleLookInoculationQuantity(index) {
      const item = this.tableData[index];
      this.$refs.refPickUpNumDlg.open(item);
    },
    handleLookNumberCustomers(index) {
      const item = this.tableData[index];
      this.$refs.refClientNumDlgDlg.open(item);
    },
    getSalesDataStatistics() {
      getSalesDataStatistics().then((data) => {
        if (data) {
          for (let key in data) {
            if (this.statisticsData.hasOwnProperty(key)) {
              this.statisticsData[key] = data[key];
            }
          }
        }
      });
    },
    handleExpand() {
      this.expanded = !this.expanded;
    },
    sortChange(val) {
      /**
       * 排序规则；1：按照业务员工号正序排序；
       * 2：按照业务员工号倒叙排序；
       *
       * 3：按照客户数量正序排序；
       * 4：按照客户数量倒叙排序；
       *
       * 5：按照接种数量正序排序；
       * 6：按照接种数量倒序排序；
       * 7：按照团员人数正序排序；
       * 8：按照团员人数倒序排序；
       * 9：按照上月预估金额正序排序；
       * 10：按照上月预估金额倒序排序；
       * 11：按照本月预估金额正序排序；
       * 12：按照本月预估金额倒序排序；
       * 13：按照可提现余额正序排序；
       * 14：按照可提现余额倒序排序；
       * 15：按照已提现金额正序排序；
       * 16：按照已提现金额倒序排序；
       * 17：按照最后访问时间正序排序；
       * 18：按照最后访问时间倒序排序；
       */
      if (val.order) {
        const findedItem = this.tableOption.find(
          (item) => item.prop === val.prop
        );
        if (findedItem && findedItem.sortNum) {
          if (val.order == "ascending") {
            ////升序
            this.formRef.sortTag = findedItem.sortNum;
          } else {
            this.formRef.sortTag = findedItem.sortNum + 1;
          }
        }
      } else {
        const findedItem = this.tableOption.find(
          (item) => item.prop === val.prop
        );
        if (findedItem) {
          this.formRef.sortTag = "";
        }
      }

      this.page.current = 1;
      this.getList();
    },
    resetForm() {
      let sortTag = this.formRef.sortTag;
      for (let key in this.formRef) {
        this.formRef[key] = "";
      }
      this.formRef.sortTag = sortTag;

      this.registrationTime = "";
      this.lastAccessTime = "";
      this.$refs.refSelectArea.clear();
    },
    handleSearch() {
      this.page.current = 1;
      this.getList();
    },
    getList() {
      const { current, size } = this.page;
      let params = {
        current,
        size,
        sortTag: this.formRef.sortTag,
      };
      //注册时间
      if (this.registrationTime) {
        this.formRef.registrationStartTime = dayjs(
          this.registrationTime[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        this.formRef.registrationEndTime = dayjs(
          this.registrationTime[1]
        ).format("YYYY-MM-DD HH:mm:ss");
      }
      //最后访问时间
      if (this.lastAccessTime) {
        this.formRef.lastAccessStartTime = dayjs(this.lastAccessTime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formRef.lastAccessEndTime = dayjs(this.lastAccessTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      if (this.expanded) {
        _.merge(params, this.formRef);
        params.nameLike = "";
      } else {
        params.nameLike = this.formRef.nameLike;
      }

      getSalesUserStatisticsManage(params).then((data) => {
        if (data) {
          const { records, total } = data;
          this.page.total = total;
          this.tableData = records;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/index.scss";

.statics {
  display: flex;
  flex-direction: row;

  .item {
    height: 80px;
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 0 16px;
    box-sizing: border-box;
    min-width: 120px;

    &:not(:first-child) {
      margin-left: 8px;
    }

    .tip {
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #000000;
    }

    .value {
      font-size: 24px;
      font-weight: 700;
      text-align: center;
      color: #000000;
      margin-top: 8px;

      .small {
        font-size: 16px;
        font-weight: 700;
        text-align: left;
      }
    }

    &.red {
      background: #f5222d;
      border: 1px solid #f5222d;

      .tip {
        color: #ffffff;
      }
      .value {
        color: #ffffff;
      }
    }
  }
}

.sales-id-view {
  display: inline-block;
  cursor: pointer;
  color: #f5222d;
}

.default-icon {
  color: #595959;
}
</style>
